import { $host } from "./index";

export const getChats = async (adminId, type, search, limit, offset, sortBy = 'recent', filterByUnread = false, categoryId = null) => {
    const params = new URLSearchParams({
        admin_id: adminId,
        type: type,
        search: search || '',
        limit: limit,
        offset: offset,
        sort_by: sortBy,
        filter_by_unread: filterByUnread
    });
    
    if (categoryId) {
        params.append('category_id', categoryId);
    }
    
    const {data} = await $host.get(`web/chats/?${params.toString()}`);
    return data;
}

export const getClosedChatsStats = async (adminId, categoryId = null) => {
    const params = new URLSearchParams({
        admin_id: adminId,
        type: 'closed',
        search: '',
        limit: 1,
        offset: 0,
        sort_by: 'recent',
        filter_by_unread: false
    });

    if (categoryId) {
        params.append('category_id', categoryId);
    }

    const {data} = await $host.get(`web/chats/?${params.toString()}`);
    return data?.stats || { unreadCount: 0, requestsCount: 0 };
}

export const getOpenedChatsStats = async (adminId, categoryId = null) => {
    const params = new URLSearchParams({
        admin_id: adminId,
        type: 'opened',
        search: '',
        limit: 1,
        offset: 0,
        sort_by: 'recent',
        filter_by_unread: false
    });

    if (categoryId) {
        params.append('category_id', categoryId);
    }

    const {data} = await $host.get(`web/chats/?${params.toString()}`);
    return data?.stats || { unreadCount: 0, requestsCount: 0 };
}

export const getMyChatsStats = async (adminId, categoryId = null) => {
    const params = new URLSearchParams({
        admin_id: adminId,
        type: 'my',
        search: '',
        limit: 1,
        offset: 0,
        sort_by: 'recent',
        filter_by_unread: false
    });

    if (categoryId) {
        params.append('category_id', categoryId);
    }

    const {data} = await $host.get(`web/chats/?${params.toString()}`);
    return data?.stats || { unreadCount: 0, requestsCount: 0 };
}

export const getChat = async (chatId) => {
    const {data} = await $host.get(`web/chats/${chatId}`);
    return data;
}

export const getChatByUserId = async (userId, categoryId = null) => {
    const url = categoryId 
        ? `web/chats/byUserId/${userId}?category_id=${categoryId}`
        : `web/chats/byUserId/${userId}`;
    const {data} = await $host.get(url);
    return data;
}

export const fetchMessages = async (chatId, limit, offset, dateOrder = 'ASC') => {
    const {data} = await $host.get(`web/chats/${chatId}/messages?limit=${limit}&offset=${offset}&date_order=${dateOrder}`);
    return data;
}


export const postMessage = async (chatId, fromUserId, message) => {
    const {data} = await $host.post(`web/chats/${chatId}/messages`, {fromUserId, message});
    return data;
}

// Send message with media attachments using multipart/form-data
export const postMessageWithMedia = async (chatId, fromUserId, message, files = [], platform = null) => {
    const formData = new FormData();
    formData.append('fromUserId', fromUserId);
    if (message) formData.append('message', message);
    if (platform) formData.append('platform', platform);

    // append up to 10 files
    files.slice(0, 10).forEach((file) => {
        formData.append('media', file);
    });

    const { data } = await $host.post(`web/chats/${chatId}/messages`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
    return data;
}

export const getChatPlatforms = async (chatId) => {
    const { data } = await $host.get(`web/chats/${chatId}/platforms`);
    return data;
}

export const requestCloseChat = async (chatId, userId) => {
    const {data} = await $host.post(`web/chats/${chatId}/close`, {userId});
    return data;
}

export const requestOpenChat = async (chatId, userId) => {
    const {data} = await $host.post(`web/chats/${chatId}/open`, {userId});
    return data;
}

export const markChatAsRead = async (chatId) => {
    const {data} = await $host.post(`web/chats/${chatId}/read`);
    return data;
}

export const fetchOnePost = async(id) => {
    const {data} = await $host.get('web/posts/' + id);
    return data;
}

// Edit an existing message text
export const editMessage = async (chatId, messageId, fromUserId, newText) => {
    const { data } = await $host.post(`web/chats/${chatId}/messages/${messageId}/edit`, {
        fromUserId,
        newText,
    });
    return data;
}

export const getChatMessageTemplates = async () => {
    const { data } = await $host.get('web/chats/all/templates');
    return data;
}

export const createChatMessageTemplate = async (title, message) => {
    const { data } = await $host.post('web/chats/all/templates', { title, message });
    return data;
}

export const updateChatMessageTemplate = async (templateId, title, message) => {
    const { data } = await $host.put(`web/chats/all/templates/${templateId}`, { title, message });
    return data;
}

export const deleteChatMessageTemplate = async (templateId) => {
    const { data } = await $host.delete(`web/chats/all/templates/${templateId}`);
    return data;
}
